const formatPrice = (price?: number) => {
  // eslint-disable-next-line eqeqeq
  if (price == undefined) return undefined;
  return (price / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'narrowSymbol',
  });
};

export default formatPrice;
